import { defineStore } from 'pinia';

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    permissions: [],
  }),
  actions: {
    setPermissions(perms) {
      this.permissions = perms;
    },
    hasPermission(permission) {
      return this.permissions.includes(permission);
    },
  },
  persist: true
});
